// Generated by BUCKLESCRIPT VERSION 3.1.5, PLEASE EDIT WITH CARE
'use strict';

var ReasonReact = require("reason-react/src/ReasonReact.js");
var GatsbyLink = require("gatsby-link");
var Js_null_undefined = require("bs-platform/lib/js/js_null_undefined.js");

function make(to_, className, style, children) {
  return ReasonReact.wrapJsForReason(GatsbyLink.default, {
              to: to_,
              className: Js_null_undefined.fromOption(className),
              style: Js_null_undefined.fromOption(style)
            }, children);
}

exports.make = make;
/* ReasonReact Not a pure module */



// WEBPACK FOOTER //
// ./src/bindings/gatsby/link.js